import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchUser } from './api';
import UsageNodeCharts from './UsageNodeCharts';

export default function UsageUserDetail({ userId, name, range, theme }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['mgmt-usage-user', userId, range],
    queryFn: () => fetchUser({ userId, range }),
  });

  if (isLoading) return <div className="py-12 text-center text-gray-500">Loading…</div>;
  if (error) return <div className="py-12 text-center text-red-500">Failed to load user usage.</div>;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">{name || data.user?.name}</h2>
        <span className="text-sm text-gray-500">
          Last active: {data.last_active ? new Date(data.last_active).toLocaleString() : '—'}
        </span>
      </div>
      <UsageNodeCharts compartments={data.compartments} trend={data.trend} theme={theme} />
    </div>
  );
}
